export function queryFocusableElements(element) {
    const focusableNodes = element.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
    const focusableArr = Array.from(focusableNodes);
    const focusable = [...focusableArr].filter((el) => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));
    return focusable;
}
